import "./CreateExerciseScreen.css"
import {useState} from "react";
import TaskCreator from "./components/TaskCreator";
import {apiClient} from "../../api/apiClient";
import {Bounce, toast, ToastContainer} from "react-toastify";

const CreateExerciseScreen = () => {
    const [tasks, setTasks] = useState([]);

    const notify = (message) => toast(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
    });
    
    const handleAddTask = (task) => {
        setTasks(prev => {
            return [...prev, task];
        })
    }

    const onEditTask = (task, index) => {
        const array = [...tasks];
        array[index] = {...array[index], questions: task};
        setTasks(array);
    }

    const onRemoveTask = (index) => {
        const array = [...tasks];
        const newArray = array.filter((_, i) => i !== index);
        setTasks(newArray);
    }

    const handleCreateExercise = () => {
        const form = new FormData();
        
        form.append("jsonData", JSON.stringify(tasks));
        
        tasks.map(task => {
            task.questions.map(question => {
                form.append(question.id, question.image);
            })
        })
        
        apiClient.post('/exercises', form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.isSuccess) {
                notify('Sukces! 🦄')
            } else {
                notify('Błąd, sprawdź konsolę! 🦄')
            }
            console.log('[CreateExerciseScreen] 🚀 ', JSON.stringify(response, null, 2));
        })
    }

    return (
        <div className={"screen"}>
            <div className={"half"}>
                {tasks.map((item, index) => {
                    return <TaskCreator
                        key={`creator-${item.id}`}
                        index={index}
                        isEditMode
                        initialQuestions={item.questions}
                        onEditTask={onEditTask}
                        onRemove={onRemoveTask}
                    />
                })}
            </div>
            <TaskCreator onPressAdd={handleAddTask} />
            <button className={"createButton"} onClick={handleCreateExercise}>Dodaj ćwiczenie</button>
            <ToastContainer/>
        </div>
    )
}

export default CreateExerciseScreen;